var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class StageInnerMeasure {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get stage() {
        return this.parent;
    }
    get app() {
        return this.stage.app;
    }
    get stageHeightInUnits() {
        return Math.round(this.stageHeightInPixel / this.stageHeightRatio);
    }
    get stageWidthInUnits() {
        return Math.round(this.stageWidthInPixel / this.stageWidthRatio);
    }
    get stageHeightInPixel() {
        if (this.stage.stageTypeInfo.isDraftStage) {
            return this.stage.draftLayout.height;
        }
        return this.app.appMeasure.appHeightInPixel - 45;
    }
    get stageWidthInPixel() {
        if (this.stage.stageTypeInfo.isDraftStage) {
            return this.stage.draftLayout.width;
        }
        return this.app.appMeasure.appWidthInPixel;
    }
    get aspectRatio() {
        return this.stageWidthInPixel / this.stageHeightInPixel;
    }
    get stageHeightRatio() {
        return this.stageHeightInPixel / 1000;
    }
    get stageWidthRatio() {
        return this.stageWidthInPixel / 1000;
    }
    get stageDiagonalRatio() {
        return (this.stageHeightInPixel / 1000 + this.stageWidthInPixel / 1000) / 2;
    }
}
__decorate([
    computed
], StageInnerMeasure.prototype, "stageWidthInPixel", null);
